module.exports = __webpack_public_path__ + "img/download.9a3f750d.svg";